import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {WorkOrderService} from '../../../../Services/work-order.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {WoAsset} from '../../../../DataModels/workorder-model';

@Component({
  selector: 'app-asset-detail',
  templateUrl: './asset-detail.component.html',
  standalone: false,
})
export class AssetDetailComponent implements OnInit {

  assetId: string | null = null;
  asset: WoAsset | null = null;
  history: any[] = [];
  isLoaded = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private woService: WorkOrderService,
    private notification: BsToastService,
  ) {
  }

  ngOnInit(): void {
    this.assetId = this.route.snapshot.queryParamMap.get('id');
    if (this.assetId) {
      this.load();
    }
  }

  load(): void {
    this.woService.getAsset(this.assetId!).subscribe({
      next: (res) => {
        this.asset = res;
        this.woService.getAssetHistory(this.assetId!).subscribe({
          next: (h) => {
            this.history = h;
            this.isLoaded = true;
          },
          error: () => {
            this.isLoaded = true;
          }
        });
      },
      error: () => {
        this.notification.showErrorToast('Error loading asset.');
        this.isLoaded = true;
      }
    });
  }

  edit(): void {
    this.router.navigate(['/work-orders/assets/asset-form'], {queryParams: {id: this.assetId}});
  }

  goToWo(id: string): void {
    this.router.navigate(['/work-orders/work-orders-form'], {queryParams: {id}});
  }

  back(): void {
    this.router.navigate(['/work-orders/assets/asset-list']);
  }
}
